import {makeIconButtonControl} from '../../controls/icon-button-control/icon-button-control';
import {ICON_BUTTON_CONTROL_ACTIONS} from '../../controls/icon-button-control/icon-button-control.types';
import type {EmailMakerControl} from '../../right-panel-registry.types';

/** Shared toolbar action singletons; the controls resolve the editor from context, so one instance per action is interchangeable across sectors. */
export const duplicateControl: EmailMakerControl = makeIconButtonControl({
  action: ICON_BUTTON_CONTROL_ACTIONS.DUPLICATE,
  labelKey: 'pmwjs_duplicate',
  iconClass: 'icon-copy',
});

export const lockControl: EmailMakerControl = makeIconButtonControl({
  action: ICON_BUTTON_CONTROL_ACTIONS.LOCK,
  labelKey: 'pmwjs_lock',
  iconClass: 'icon-lock',
});

export const deleteControl: EmailMakerControl = makeIconButtonControl({
  action: ICON_BUTTON_CONTROL_ACTIONS.DELETE,
  labelKey: 'pmwjs_delete',
  iconClass: 'icon-delete',
});
